import { render, staticRenderFns } from "./AttachmentCategoryCard.vue?vue&type=template&id=c4592652&"
import script from "./AttachmentCategoryCard.vue?vue&type=script&lang=js&"
export * from "./AttachmentCategoryCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports